import {CHANGE_ITEM_QUANTITY, LOAD_ITEMS, UPDATE_ITEMS_PROPS, UPDATE_ITEMS_AVAILABILITY} from '../../actions/actionTypes';
import {FIELD_SELECTED_ORDER} from '../../common/constants';


let itemOrder = 0;

export function increaseItemOrder() {
    return ++itemOrder;
}
export function storeItemsListReducer(state, action) {
    state = state || {};
    switch (action.type) {
        case CHANGE_ITEM_QUANTITY: {
            //console.log("state:"+JSON.stringify(state));
            //console.log("action:"+JSON.stringify(action));
            const newQuantity = action.newQuantity;//state[action.key].quantity + 1;
            let newState = Object.assign({}, state);
            let newItem = Object.assign({}, newState[action.key]);
            newItem[FIELD_SELECTED_ORDER] = newQuantity === 0
                ? undefined
                : newItem[FIELD_SELECTED_ORDER] || increaseItemOrder();
            newItem.quantity = newQuantity;
            newState[action.key] = newItem;
            if (newItem.variation) {
                let defaultBoxItem = newItem.defaultBoxItem;
                if (defaultBoxItem) {
                    let newDefaultBoxItem = Object.assign({}, newState[defaultBoxItem]);
                    newDefaultBoxItem.variations = Object.assign([], newDefaultBoxItem.variations);
                    for (let i = 0; i < newDefaultBoxItem.variations.length; i++) {
                        if (newDefaultBoxItem.variations[i].key === action.key) {
                            newDefaultBoxItem.variations[i] = newItem;
                            break;
                        }
                    }
                    newState[defaultBoxItem] = newDefaultBoxItem;
                }
            }
            //console.log("new state:"+JSON.stringify(newState));
            return newState;
        }
        case LOAD_ITEMS:
            return Object.assign({}, action.data);
		case UPDATE_ITEMS_PROPS: {
            let newState = Object.assign({}, state);
            for (const key in action.items) {
                if(action.items.hasOwnProperty(key)) {
                    newState[key] = action.items[key];
                }
            }
            return newState;
        }
		case UPDATE_ITEMS_AVAILABILITY: {
            let newState = Object.assign({}, state);
            for (const key in action.items) {
                if(action.items.hasOwnProperty(key)) {
                    if (newState[key]) {
                        newState[key].available = action.items[key].available;;
                    }
                }
            }
            return newState;
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/store/storeItemsListReducer.js